module.exports = require("crypto");;